import utilsAuth from '@/utils/auth';
import passportApi from '@/api/passport';
import shopApi from '@/api/shop';

const user = {
	state: {
		name: '',
		status: '',
		token: utilsAuth.getAccessToken(),
		avatar: '',
		introduction: '',
		roles: [],
		shopList: [],
		shopInfo: utilsAuth.getShopInfo(),
		merchantInfo: utilsAuth.getMerchantInfo(),
		sellerInfo: utilsAuth.getSellerInfo()
	},
	mutations: {
		SET_TOKEN: (state, token) => {
      		state.token = token
    	},
    	SET_ROLES: (state, roles) => {
      		state.roles = roles
    	},
    	SET_SELLER: (state, data) => {
    		state.sellerInfo = data
    	},
    	SET_SHOP: (state, data) => {
    	    state.shopInfo = data
    	},
    	SET_MERCHANT: (state, data) => {
    		state.merchantInfo = data
    	},
        SET_SHOPLIST: (state, data) => {
    		state.shopList = data
        }
	},
	actions: {
		Login ({ commit }, loginData) {
			return new Promise((resolve, reject) => {
				passportApi.postLogin(loginData.account, loginData.password).then(response => {
					if (response.data.status === 'succ') {
						const data = response.data.data
						commit('SET_TOKEN', data.token)
						utilsAuth.setAccessToken(data.token)
						utilsAuth.setSaltTokenToken(data.salt)

						commit('SET_SELLER', data.seller)
						commit('SET_SHOP', data.shop)
						commit('SET_MERCHANT', data.merchants)
						utilsAuth.setSellerInfo(data.seller)
						utilsAuth.setShopInfo(data.shop)
						utilsAuth.setMerchantInfo(data.merchants)
                        this.dispatch('GetShopList')
                        // 重置权限
                        commit('SET_ROLES', '')
					}
					resolve(response.data)
				}).catch(error => {
          			reject(error)
        		})
			})
		},
		GetShopInfo ({ commit, state }) {
			return new Promise((resolve, reject) => {
                const merchantInfo = state.merchantInfo
                const shopInfo = state.shopInfo
                const roles = getRoles()
                commit('SET_ROLES', roles)

                shopApi.getAccountPermission().then(response => {
                    const data = response.data.data

                    const result = {
                        roles: roles,
                        sellerWorkground: [],
                        proWorkground: []
                    }

                    if (data.seller_workground.length) {
                        result.sellerWorkground = data.seller_workground
                    }

                    if (data.pro_workground.length) {
                        result.proWorkground = data.pro_workground  
                    }

                    resolve(result)
                })

                // 生成基础角色
                function getRoles () {
                    let roles = []
                    // 连锁店铺权限
                    if (Number(merchantInfo.merchants_type) === 2) {
                        roles.push('chainAdmin')
                    }

                    // 默认店铺权限
                    if (Number(shopInfo.is_default) === 1) {
                        roles.push('defaultAdmin')
                    }

                    if (Number(merchantInfo.merchants_type) === 2 && Number(shopInfo.is_default) === 1) {
                        roles.push('chainWithDefaultAdmin')
                    }

                    return roles
                }
			})
		},
		GetShopList ({ commit, state }) {
			return new Promise((resolve, reject) => {
                if (Number(state.shopInfo.is_default) === 1 && Number(state.merchantInfo.merchants_type) === 2) {
				    passportApi.getShopList().then(response => {
					    if (response.data.status === 'succ') {
						    const info = response.data.data
                            // 更新店铺信息,兼容刷新的情况
                            let _shopInfo = utilsAuth.getShopInfo();
                            info.forEach(val => {
                                if (Number(val.shop_id) === Number(_shopInfo.shop_id) && Number(val.shop_id) > 0) {
                                    commit('SET_SHOP', val);
						            utilsAuth.setShopInfo(val)
                                }
                            });
						    commit('SET_SHOPLIST', info)
						    resolve(info)
					    } else {
						    reject(new Error('Login error'))
					    }
				    }).catch(error => {
          			    reject(error)
        		    })
                } else {
                    shopApi.getShopInfo().then(response => {
                        if (response.data.status === 'succ') {
                            let _data = response.data.data;
                            commit('SET_SHOP', _data);
						    utilsAuth.setShopInfo(_data)
						    resolve(_data)
                        } else {
						    reject(new Error('Login error'))
                        }
				    }).catch(error => {
          			    reject(error)
        		    })
                }
			})
		},
		LogOut ({ commit, state }) {
			return new Promise((resolve, reject) => {
				commit('SET_TOKEN', '')
                commit('SET_ROLES', '')
				utilsAuth.removeAccessToken()
				utilsAuth.removeSaltTokenToken()
				localStorage.clear()
				resolve()
			})
		}
	}
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js